import { jwtVerify } from 'jose';
import AuthEngine from "./auth-engine";
import { STORAGE_KEYS, Storage } from '../../utils/store';

const auth = new AuthEngine();

const AuthGuard = {
    isAuthenticated() {
        const token = Storage.get(STORAGE_KEYS.JWT) ?? '';
            
        return jwtVerify(token, new TextEncoder().encode(process.env.GENDLOC_JWT_SECRET_KEY))
            .then(data => {
                Storage.store(STORAGE_KEYS.USER, data.payload, true);
                return true;
            })
            .catch(() => auth.refresh(Storage.get(STORAGE_KEYS.JWT_RENEW)));
    },

    httpClient: (url, params) => {
        if (!('Authorization' in params.headers)) {
            params.headers['Authorization'] = `Bearer ${Storage.get(STORAGE_KEYS.JWT)}`
        }

        return fetch(url, params)
            .then(async res => {
                if (res.status !== 401) { return res; }

                const refreshed = await auth.refresh(Storage.get(STORAGE_KEYS.JWT_RENEW));

                if (refreshed) {
                    params.headers['Authorization'] = `Bearer ${Storage.get(STORAGE_KEYS.JWT)}`;
                    return fetch(url, params);
                }

                AuthGuard.redirectToLogin();
            });
    },

    redirectToLogin: () => {
        Storage.store(STORAGE_KEYS.REDIRECT_AFTER_LOGIN, window.location.href, true);

        Storage.clear(STORAGE_KEYS.JWT);
        Storage.clear(STORAGE_KEYS.JWT_RENEW);

        window.location.reload();
    },

    login: (username, password) => auth.login(username, password),
    logout: () => auth.logout()

}
export default AuthGuard;
